import { isAxiosError } from 'axios'
import { Navigate } from 'react-router'

import { SkeletonRows } from '@/components/ui/skeleton'
import { PolicyChangeStatus, usePolicyChange } from '@/models/policyChange'
import type { Org } from '@/models/user'
import { PolicyChangeForm } from '../PolicyChanges/PolicyChangeForm'

/**
 * Staff start a policy change for a customer from the console, in the customer's own guided form, and send
 * it for them. `path` is `new`, or a draft's id to carry on with; a request past its draft opens in the queue.
 */
export function PolicyChangeTab({ org, path }: { org: Org; path: string[] }) {
  const [requestId] = path
  const isNew = !requestId || requestId === 'new'
  const { data: request, isLoading, error } = usePolicyChange(org.id, isNew ? undefined : requestId)

  if (isNew) return <PolicyChangeForm forCustomer={org} />
  if (isLoading) return <SkeletonRows className="mt-10" rows={6} />
  if (!request) {
    const missing = isAxiosError(error) && error.response?.status === 404
    return (
      <div className="mt-10 text-center text-sm">
        {missing ? 'Request not found' : 'Couldn’t load this request. Refresh to try again.'}
      </div>
    )
  }
  if (request.status !== PolicyChangeStatus.DRAFT) {
    return <Navigate to={`/insure/internal/endorsements/${request.id}?view=open`} replace />
  }
  return <PolicyChangeForm request={request} forCustomer={org} />
}
